import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ESaveSearchActionType } from './types';

export const closeSaveSearchModal = actionGenerator<ESaveSearchActionType.ModalClosed>(
  ESaveSearchActionType.ModalClosed,
);
